import { z } from 'zod';
import { ReadDefensoriaDto } from '@/api.types';
import { normalizeDefensoriaFormFromApi } from '@/modules/structure/defensoria/defensoria-form.utils';
import {
  optionalReferenceIdSchema,
  requiredIntFromNumberInput,
  requiredReferenceIdSchema,
  telefoneFormSchema,
} from '@/shared/utils/formZod.schema.utils';

function nullToEmpty(val: unknown): string {
  return val == null ? '' : String(val);
}

const optionalBooleanSchema = z.preprocess(
  (val) => (val == null ? undefined : val),
  z.boolean().optional(),
);

const optionalNullableStringSchema = z.preprocess(nullToEmpty, z.string().optional());

const defensoriaFormBaseSchema = z
  .object({
    ordem: requiredIntFromNumberInput({
      requiredMessage: 'Informe a ordem',
      min: 0,
      minMessage: 'A ordem deve ser zero ou maior',
    }),
    nome: z.string().trim().min(1, 'Informe o nome da defensoria'),
    codigo: optionalNullableStringSchema,
    vara: requiredReferenceIdSchema,
    comarca: requiredReferenceIdSchema,
    predio: requiredReferenceIdSchema,
    defensoriasubstituta1: optionalReferenceIdSchema,
    defensoriasubstituta2: optionalReferenceIdSchema,
    diretoria: optionalReferenceIdSchema,
    telefone: telefoneFormSchema,
    maximo_estagiarios: requiredIntFromNumberInput({
      requiredMessage: 'Informe o máximo de estagiários',
      min: 0,
      max: 99,
      minMessage: 'Mínimo 0',
      maxMessage: 'Máximo 99',
    }),
    anotacao: optionalNullableStringSchema,
    exibirrelatorio: optionalBooleanSchema,
    relatoriosAtividadesHabilitado: optionalBooleanSchema,
    criminal: optionalBooleanSchema,
    civel: optionalBooleanSchema,
  })
  .passthrough();

/** Campos validados no formulário de cadastro/edição (CreateDefensoriaDto / UpdateDefensoriaDto). */
export const defensoriaFormSchema = z.preprocess(
  (val) =>
    val != null && typeof val === 'object'
      ? normalizeDefensoriaFormFromApi(val as ReadDefensoriaDto)
      : val,
  defensoriaFormBaseSchema,
);

export type DefensoriaFormValues = z.infer<typeof defensoriaFormBaseSchema>;
